module.exports = __webpack_public_path__ + "assets/img/d724d6fe2f4db8d35b887789daefaacf.png";